'use strict';
'use es6';

// matches /sales/FLOW_NAME/1234567890

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = /^(?:\/(?:[A-Za-z0-9-_]*)){2}\/(\d+)(?:\/|$)/;
module.exports = exports['default'];